import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "chip-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "chip-container" }
const _hoisted_6 = { key: 2 }

import Dropdown from "primevue/dropdown";
import Skeleton from "primevue/skeleton";

import { ref, watch, onMounted, computed, nextTick } from "vue";
import { useCatalogData } from "./useCatalogData";
import PlatformChip from "@/shared/chips/PlatformChip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogDataSingleInput',
  props: [
  "modelValue",
  "isDisabled",
  "selectType",
  "useIdOnly",
  "isInvalid",
  "isValueSetted",
  "notSearch",
  "filterField",
  "filterValue",
  "filterList",
  "filterFields",
  "filterValues",
],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const catalogDataSettings = ref({
  isLoading: false,
  filterStr: "",
  debounceTimeout: null as number | null,
  isLoadingFirst: true,
  optionName: "",
  optionValue: "",
  isLoadedAll: false,
});

const {
  store,
  items,
  optionName,
  addScrollHundler,
  updateSettings,
  onFilterItems,
  getSortingArray,
  sendItemRequest,
  replaceItems,
  objectToValue,
} = useCatalogData(
  props.selectType,
  catalogDataSettings.value,
  props.useIdOnly
);

let element: Element | null = null;

const findItemByValue = (value: any) => {
  if (value == null) return null;

  const searchValue =
    typeof value === "object" ? value[optionName.value.pk] : value;

  return items.value.find((item: any) => {
    const itemValue = item[optionName.value.pk];
    return itemValue == searchValue;
  });
};

const loadMissingValue = (value: any) => {
  if (typeof value === "object" || value === null) return;

  catalogDataSettings.value.isLoading = true;
  store.getItems("", [objectToValue(value)], true, true).then(() => {
    setTimeout(() => {
      catalogDataSettings.value.isLoading = false;
    }, 200);
  });
};

const checkAndLoadValue = (value: any) => {
  if (value == null) return;

  const foundItem = findItemByValue(value);

  if (!foundItem) {
    if (typeof value === "object") {
      const pkValue = value[optionName.value.pk];
      if (pkValue != null) {
        loadMissingValue(pkValue);
      }
    } else {
      loadMissingValue(value);
    }
  }
};

watch(
  () => catalogDataSettings.value.filterStr,
  () => {
    store.sortItems(getSortingArray([props.modelValue]));
    if (catalogDataSettings.value.debounceTimeout)
      clearTimeout(catalogDataSettings.value.debounceTimeout);
    catalogDataSettings.value.debounceTimeout = setTimeout(
      sendItemRequest,
      1000,
      [props.modelValue]
    );
  },
  { immediate: true }
);

watch(
  () => catalogDataSettings.value,
  (newValue) => {
    updateSettings(newValue);
  }
);

watch(
  () => props.modelValue,
  (newValue, oldValue) => {
    if (catalogDataSettings.value.isLoadingFirst && newValue != null) {
      catalogDataSettings.value.isLoading = true;
      store.getItems("", [objectToValue(newValue)], true, true).then(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        setTimeout(() => {
          catalogDataSettings.value.isLoading = false;
        }, 200);
      });
    } else if (!catalogDataSettings.value.isLoadingFirst && newValue != null && newValue !== oldValue) {
      nextTick(() => {
        checkAndLoadValue(newValue);
      });
    }
  },
  { immediate: true }
);

watch(
  () => items.value.length,
  (itemsLength) => {
    if (
      itemsLength > 0 &&
      !catalogDataSettings.value.isLoadingFirst &&
      props.modelValue != null
    ) {
      checkAndLoadValue(props.modelValue);
    }
  }
);

onMounted(() => {
  if (!store.itemList.length) {
    catalogDataSettings.value.isLoading = true;
    store
      .getItems(
        "",
        getSortingArray([props.modelValue]),
        true,
        true,
        0,
        50,
        true
      )
      .then(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
        checkAndLoadValue(props.modelValue);
      })
      .catch(() => {
        catalogDataSettings.value.isLoadingFirst = false;
        catalogDataSettings.value.isLoading = false;
      });
  } else if (store.isLoadingInitial && store.initialLoadPromise) {
    catalogDataSettings.value.isLoading = true;
    store.initialLoadPromise.then(() => {
      catalogDataSettings.value.isLoadingFirst = false;
      catalogDataSettings.value.isLoading = false;
      checkAndLoadValue(props.modelValue);
    })
    .catch(() => {
      catalogDataSettings.value.isLoadingFirst = false;
      catalogDataSettings.value.isLoading = false;
    });
  } else {
    catalogDataSettings.value.isLoadingFirst = false;
    nextTick(() => {
      checkAndLoadValue(props.modelValue);
    });
  }
});

const isLoading = computed(() => {
  const loading = catalogDataSettings.value.isLoading || catalogDataSettings.value.isLoadingFirst;
  return loading;
});

const isEmpty = computed(() => {
  return filteredItems.value.length === 0;
});

const emptyMessageComputed = computed(() => {
  return isLoading.value ? 'Поиск вариантов...' : 'Нет доступных вариантов';
});

const emptyFilterMessageComputed = computed(() => {
  return isLoading.value ? 'Поиск вариантов...' : 'Результатов не найдено';
});

const normalizedModelValue = computed(() => {
  if (props.modelValue == null) return null;

  if (props.useIdOnly) {
    return props.modelValue;
  }

  if (typeof props.modelValue === "object") {
    const pkValue = props.modelValue[optionName.value.pk];
    if (pkValue != null) {
      const foundItem = items.value.find((item: any) => {
        return item[optionName.value.pk] == pkValue;
      });
      if (foundItem) {
        return foundItem;
      }
      return props.modelValue;
    }
  }

  return props.modelValue;
});

const filteredItems = computed(() => {
  if (props.filterField && props.filterValue) {
    return items.value.filter(
      (item: any) => item[props.filterField] == props.filterValue
    );
  }

  if (props.filterList && props.filterField) {
    return items.value.filter(
      (item: any) => !props.filterList.includes(item[props.filterField])
    );
  }

  if (
    props.filterFields &&
    props.filterValues &&
    props.filterFields.length == props.filterValues.length
  ) {
    let newItems = items.value;
    for (let i = 0; i < props.filterFields.length; i++) {
      newItems = newItems.filter(
        (item: any) => item[props.filterFields[i]] == props.filterValues[i]
      );
    }
    return newItems;
  }
  return items.value;
});

const beforeShowItems = () => {
  store.sortItems(getSortingArray([props.modelValue]));
};

const showItems = () => {
  element = document.querySelectorAll(
    ".p-dropdown-panel .p-dropdown-items-wrapper"
  )[0];
  if (element) addScrollHundler(element);
};

const findItem = (pk: string) => {
  return items.value.filter((e: any) => e[optionName.value.pk] == pk)[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), {
    modelValue: normalizedModelValue.value,
    options: filteredItems.value,
    optionLabel: _unref(optionName).label,
    placeholder: isLoading.value && isEmpty.value ? 'Поиск вариантов...' : (__props.isValueSetted ? 'Не выбрано' : 'Выберите значение'),
    disabled: __props.isDisabled || (isLoading.value && isEmpty.value),
    filter: !__props.isDisabled && !__props.notSearch,
    onFilter: _unref(onFilterItems),
    "option-value": __props.useIdOnly ? _unref(optionName).pk : undefined,
    invalid: __props.isInvalid,
    onShow: showItems,
    onBeforeShow: beforeShowItems,
    showToggleAll: !__props.isDisabled,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = 
      ($event) => {
        emit('update:modelValue', $event);
        catalogDataSettings.value.isLoadingFirst = false;
      }
    ),
    showClear: "",
    loading: isLoading.value,
    emptyMessage: emptyMessageComputed.value,
    emptyFilterMessage: emptyFilterMessageComputed.value
  }, {
    value: _withCtx((slotProps) => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["loading-value-placeholder", 
          props.modelValue && props.modelValue.length != 0 ? 'any-catalog' : ''
        ])
          }, "   ", 2))
        : (__props.selectType == 'platform' && slotProps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (findItem(slotProps.value) != undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(PlatformChip, {
                      "icon-class": slotProps.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(findItem(slotProps.value)["name"]), 1)
                      ]),
                      _: 2
                    }, 1032, ["icon-class"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    option: _withCtx((slotProps) => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_unref(Skeleton), {
                width: "10rem",
                class: "mb-2"
              })
            ])
          ]))
        : (__props.selectType == 'platform')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(PlatformChip, {
                  "icon-class": slotProps.option[_unref(optionName).pk]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(slotProps.option[_unref(optionName).label]), 1)
                  ]),
                  _: 2
                }, 1032, ["icon-class"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(slotProps.option[_unref(optionName).label]), 1))
    ]),
    _: 1
  }, 8, ["modelValue", "options", "optionLabel", "placeholder", "disabled", "filter", "onFilter", "option-value", "invalid", "showToggleAll", "loading", "emptyMessage", "emptyFilterMessage"]))
}
}

})